export default "/static/build/skin-1st.png";